export default __webpack_public_path__ + "static/media/practiceEmail.08c5b798.svg";